/* istanbul ignore file */
import { Router, Route } from 'framework/routing';
import { Routes } from 'react-router-dom';
import { GlobalProtectedRoute } from 'framework/authorization';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { ProtectedRouter } from 'infrastructure/routing';
import { READ_DEFINITIONS_LIST } from 'domain/gpo/cockpit/definition/processDefinitionService';
import ProcessDefinitionListPage from 'domain/gpo/cockpit/definition/List/ProcessDefinitionListPage';
import ProcessDefinitionRedirect from 'domain/gpo/cockpit/definition/Show/ProcessDefinitionRedirect';
import {
  PROCESS_DEFINITION_PATH,
  useProcessDefinitionRoute,
} from 'domain/gpo/cockpit/definition/processDefinitionRoute';

const ProcessDefinitionRouter: Router = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, singleEntityRoute } = useProcessDefinitionRoute();

  return (
    <ProtectedRouter basePath={PROCESS_DEFINITION_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_DEFINITIONS_LIST}>
              <ProcessDefinitionListPage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_DEFINITIONS_LIST}>
              <ProcessDefinitionRedirect />
            </GlobalProtectedRoute>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

ProcessDefinitionRouter.getRouterPath = () => '/definitions/*';

export default ProcessDefinitionRouter;
